<template>
  <!-- Mobile -->
  <ul class="mobile-nav-container" @click="menuClick">
    <li :class="{ selected: page === 'Home' }">
      <div class="router-link-container">
        <router-link to="/" @click="$emit('close')">首頁</router-link>
      </div>
    </li>

    <!-- <li :class="{ selected: page === 'Features' }">
      <div class="router-link-container">
        <router-link to="/features/suck-customer-tool" @click="$emit('close')"
          >功能介紹</router-link
        >
      </div>
    </li> -->

    <div class="router-link-container">
      <li class="nest">
        <div class="flex" @click="nestShow.solution = !nestShow.solution">
          功能介紹
          <!-- <img
            class="ml-2"
            src="@/assets/icon/arrow-down.svg"
            alt="arrow-down"
          /> -->
        </div>
        <ul v-if="nestShow.solution">
          <!-- <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'suck-customer-tool',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/suck-customer-tool"
                @click="$emit('close')"
                >吸客神器</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'remain-customer-tool',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/remain-customer-tool"
                @click="$emit('close')"
                >留客法寶</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'shop-manage-tool',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/shop-manage-tool"
                @click="$emit('close')"
                >管店專家</router-link
              >
            </div>
          </li> -->
          <li
            :class="{
              selected: page === 'Features' && featuresTab === 'reservations',
            }"
          >
            <div class="router-link-container">
              <router-link to="/features/reservations" @click="$emit('close')"
                >即時預約管理</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' &&
                featuresTab === 'device-space-management',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/device-space-management"
                @click="$emit('close')"
                >共享空間設備</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected: page === 'Features' && featuresTab === 'line-recruit',
            }"
          >
            <div class="router-link-container">
              <router-link to="/features/line-recruit" @click="$emit('close')"
                >多元拓展新客</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'grasp-repurchasers',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/grasp-repurchasers"
                @click="$emit('close')"
                >熟客持續回流</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected: page === 'Features' && featuresTab === 'promotions',
            }"
          >
            <div class="router-link-container">
              <router-link to="/features/promotions" @click="$emit('close')"
                >促購行銷活動</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'store-management',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/store-management"
                @click="$emit('close')"
                >連鎖店務管理</router-link
              >
            </div>
          </li>

          <li
            :class="{
              selected: page === 'Features' && featuresTab === 'payment-method',
            }"
          >
            <div class="router-link-container">
              <router-link to="/features/payment-method" @click="$emit('close')"
                >多元支付</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'Features' && featuresTab === 'e-commerce-business',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/features/e-commerce-business"
                @click="$emit('close')"
                >社群電商</router-link
              >
            </div>
          </li>
        </ul>
      </li>
    </div>
    <div class="router-link-container">
      <li class="nest">
        <div class="flex" @click="nestShow.industrial = !nestShow.industrial">
          產業應用
        </div>
        <ul v-if="nestShow.industrial">
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'nail-salon',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/nail-salon"
                @click="$emit('close')"
                >美甲業</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'eyelash-salon',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/eyelash-salon"
                @click="$emit('close')"
                >美睫業</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'beauty-salon',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/beauty-salon"
                @click="$emit('close')"
                >美容業</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'SPA-massage',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/SPA-massage"
                @click="$emit('close')"
                >Spa 按摩</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'hair-salon',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/hair-salon"
                @click="$emit('close')"
                >美髮沙龍</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'teeth-whitening',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/teeth-whitening"
                @click="$emit('close')"
                >美學牙科</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'aesthetic-medicine',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/aesthetic-medicine"
                @click="$emit('close')"
                >醫美診所</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'mental-therapy',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/mental-therapy"
                @click="$emit('close')"
                >心靈療癒</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' && featuresTab === 'stay-fit',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/stay-fit"
                @click="$emit('close')"
                >體態雕塑</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'yoga-course',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/yoga-course"
                @click="$emit('close')"
                >瑜珈美學</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'eyebrow-tattoo',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/eyebrow-tattoo"
                @click="$emit('close')"
                >紋繡霧眉</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'makeup-artist',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/makeup-artist"
                @click="$emit('close')"
                >彩妝服務業</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'beautiful-breast',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/beautiful-breast"
                @click="$emit('close')"
                >美胸業</router-link
              >
            </div>
          </li>
          <li
            :class="{
              selected:
                page === 'IndustrialApplication' &&
                featuresTab === 'hair-removal',
            }"
          >
            <div class="router-link-container">
              <router-link
                to="/industrial-application/hair-removal"
                @click="$emit('close')"
                >除毛業</router-link
              >
            </div>
          </li>
        </ul>
      </li>
    </div>
    <li>
      <div class="router-link-container">
        <router-link to="/blog/應用案例" @click="$emit('close')"
          >應用案例</router-link
        >
      </div>
    </li>
    <!-- <li :class="{ selected: page === 'SMSReservation' }">
      <div class="router-link-container">
        <router-link to="/sms-reservation" @click="$emit('close')"
          >簡訊預約</router-link
        >
      </div>
    </li> -->
    <li :class="{ selected: page === 'PlanContent' }">
      <div class="router-link-container">
        <router-link to="/plan-content" @click="$emit('close')"
          >方案內容</router-link
        >
      </div>
    </li>
    <li :class="{ selected: page === 'MediaMarketing' }">
      <div class="router-link-container">
        <router-link to="/media-marketing" @click="$emit('close')"
          >媒體行銷</router-link
        >
      </div>
    </li>
    <div class="router-link-container">
      <li class="nest">
        <div class="flex" @click="nestShow.ecoSystem = !nestShow.ecoSystem">
          美業生態圈
        </div>
        <ul v-if="nestShow.ecoSystem">
          <li>
            <div class="router-link-container">
              <a href="https://www.beautinq.com/partner">生態圈夥伴</a>
            </div>
          </li>

          <li
            :class="{
              selected: page === 'Columns',
            }"
          >
            <div class="router-link-container">
              <router-link to="/columns" @click="$emit('close')"
                >合作專欄</router-link
              >
            </div>
          </li>
        </ul>
      </li>
    </div>

    <div class="router-link-container">
      <li class="nest">
        <div class="flex" @click="nestShow.resource = !nestShow.resource">
          資源與活動
        </div>
        <ul v-if="nestShow.resource">
          <li
            :class="{
              selected: page === 'Blog',
            }"
          >
            <div class="router-link-container">
              <router-link to="/blog" @click="$emit('close')"
                >部落格</router-link
              >
            </div>
          </li>
          <li>
            <div class="router-link-container">
              <a target="_blank" href="https://linktr.ee/wishmobile_projects"
                >政府補助</a
              >
            </div>
          </li>
          <li>
            <div class="router-link-container">
              <a
                target="_blank"
                href="https://www.accupass.com/organizer/detail/2302140358578555600450"
                >講座活動</a
              >
            </div>
          </li>
        </ul>
      </li>
    </div>

    <!-- <li
      :class="{
        selected:
          page === 'Tutorial' ||
          page === 'TutorialList' ||
          page === 'TutorialContent',
      }"
    >
      <div class="router-link-container">
        <router-link to="/tutorial" @click="$emit('close')"
          >新手教室</router-link
        >
      </div>
    </li> -->

    <div class="router-link-container">
      <button
        class="bg-secondary-100 text-white rounded-full font-medium"
        @click="$emit('toForm')"
      >
        聯絡我們
      </button>
    </div>
  </ul>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useRoute } from 'vue-router'

defineEmits(['close', 'toForm'])

const nestShow = reactive({
  solution: false,
  industrial: false,
  ecoSystem: false,
  resource: false,
})

const route = useRoute()

const page = computed(() => route.name)
const featuresTab = computed(() => {
  return route.params.name
})
</script>

<style scoped lang="postcss">
.mobile-nav-container {
  @apply absolute top-[72px] left-0 right-0 py-[12px];
  @apply bg-white text-left  text-secondary-dark;
  z-index: 5;
}

.router-link-container {
  @apply px-[28px] py-[9px];
  a {
    @apply block;
  }
}

.nest {
  @apply cursor-pointer;
  ul {
    @apply pt-[9px];
  }
}

.nest-container {
  @apply absolute top-[75px] z-5 bg-white rounded-sm text-left !pt-0;

  > li {
    @apply py-[9px] px-[12px] hover:bg-primary-200 hover:text-white;
  }
}

.selected {
  @apply relative text-primary-100;
}

.selected::before {
  content: '';
  @apply bg-primary-200 w-full h-full absolute left-0 right-0 top-0 bottom-0;
  z-index: -1;
}

button {
  padding: 6px 20px;
  line-height: 23px;
}
</style>
